//
// Module for the Receivables Index view
//
rs.module("content/employer/reporting/receivables/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {

            var filter = $.js(jsSelectors.filter);
            var fiscalYearDropDown = filter.js(jsSelectors.fiscalYearDropDown);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Listen for fiscal year dropdown changes
            fiscalYearDropDown.change(fiscalYearChanged);

            // Hookup grid Ajax call to changing the selected fiscal year
            function fiscalYearChanged() {

                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { selectedFiscalYear: fiscalYearDropDown.val() },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);